import Authorization from '../core/Authorization';

export default {
  install(Vue) {
    const vue = new Vue({
      data: {
        authorization: new Authorization(),
      },
    });
    Vue.prototype.$authorization = vue.$data.authorization;
    Vue.prototype.$can = authorization => Vue.prototype.$authorization.can(authorization);
    Vue.prototype.$cannot = authorization => Vue.prototype.$authorization.cannot(authorization);
  },
};
